export default __webpack_public_path__ + "static/media/unum-logo.5d419db2.png";